class DifferentialController {
  constructor() {
    this.name = 'differential';
  }
}

export default DifferentialController;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential.controller.js